export default __webpack_public_path__ + "static/media/barrier-system-icon.7549b5f4.svg";